module.exports = __webpack_public_path__ + "36df05afcf3ca2e5046868c7348adb81.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/pot.png
// module id = 2785
// module chunks = 0